import { render, staticRenderFns } from "./ChatFloating.vue?vue&type=template&id=3c2e0e9a&scoped=true"
import script from "./ChatFloating.vue?vue&type=script&lang=js"
export * from "./ChatFloating.vue?vue&type=script&lang=js"
import style0 from "./ChatFloating.vue?vue&type=style&index=0&id=3c2e0e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e0e9a",
  null
  
)

export default component.exports